import React, { useEffect } from 'react';
import styled from 'styled-components';

import { IseriesItem } from '@typings/posting/series.interface';
import SeriesList from '@pages/Series/PostingDetailSeries/SeriesList';
import { motion } from 'framer-motion';
import { sideVariants } from '../../Sider';

const ModalWrapper = styled.div`
  @media (max-width: 480px) {
    width: 100%;
    height: 100dvh;

    position: fixed;
    top: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 3;
  }
`;
const SeriesWrapper = styled(motion.div)`
  width: 100% !important;
  height: calc(100% - 86px) !important;
  @media (max-width: 480px) {
    max-width: 70%;
    height: 100dvh;
    display: grid;
    grid-template-rows: auto 1fr auto;
    backdrop-filter: blur(8px);

    position: fixed;
    top: 0;
    right: 0;
    background: var(--cardBackgroundColor);
    z-index: 10;
  }
`;

type Props = {
  seriesData?: IseriesItem | null | undefined;
  docId: string | undefined;
  seriesId: string;
  setDocId: any;
  close: () => void;
};

function SeriesSec({ docId, seriesId, setDocId, close }: Props) {
  useEffect(() => {
    function blockPageScroll(e) {
      e.preventDefault();
    }
    window.addEventListener('scroll', (e) => blockPageScroll);
    return () => window.removeEventListener('scroll', blockPageScroll);
  }, []);

  return (
    <>
      <SeriesWrapper
        initial="initial"
        animate="in"
        exit="out"
        variants={sideVariants}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <SeriesList setDocId={setDocId} seriesId={seriesId} />
      </SeriesWrapper>
    </>
  );
}

export default SeriesSec;
